module.exports = __webpack_public_path__ + "static/img/ppt2.ade46561.jpeg";